<template>
  <v-container fluid grid-list-md py1>
    <v-layout row wrap>
      <v-flex md4>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ $t("view.geograficos.pais.title") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <v-flex v-show="view.elem.showForm" class="py-0">
              <v-card-text>
                <form onSubmit="return false;" @submit="submit" @keyup.ctrl.83="executeValidators">
                  <!-- Clave-->
                  <v-text-field v-if="pais.clave" v-model="pais.clave" :label="$t('view.commons.clave')" disabled />

                  <!-- Codigo -->
                  <v-text-field
                    v-model.trim="$v.pais.codigo.$model"
                    :label="$t('view.geograficos.pais.form.codigo.label')"
                    :error-messages="getFirstErrorDescription($v.pais.codigo)"
                    maxlength="2"
                    class="allcaps"
                    :disabled="view.action.submit.busy"
                    onkeypress="return /^[0-9]*$/.test(event.key);" />

                  <!-- nombre -->
                  <v-text-field
                    v-model.trim="$v.pais.nombre.$model"
                    :label="$t('view.geograficos.pais.form.nombre.label')"
                    :error-messages="getFirstErrorDescription($v.pais.nombre)"
                    maxlength="50"
                    class="allcaps"
                    :disabled="view.action.submit.busy"
                    onkeypress="return /^[a-zA-Z0-9\r\.\+\-\_\ ]+$/.test(event.key);" />

                  <!-- lada -->
                  <v-text-field
                    v-model.trim="$v.pais.lada.$model"
                    v-mask="'+###'"
                    :label="$t('view.geograficos.pais.form.lada.label')"
                    :error-messages="getFirstErrorDescription($v.pais.lada)"
                    maxlength="4"
                    :disabled="view.action.submit.busy"
                    :return-masked-value="true" />

                  <!-- Estatus-->
                  <label class="v-label mt-3">{{ $t("view.commons.status") }}</label>
                  <v-switch v-model="pais.status" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                </form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-flex shrink>
                  <v-btn
                    v-show="pais.clave && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
                    id="btnaudit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="$t('view.commons.audit')"
                    :loading="view.action.submit.busy"
                    @click="audit()">
                    <v-icon small>storage</v-icon>
                  </v-btn>

                  <v-btn id="btnclear" fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
                    <v-icon small>fa-eraser</v-icon>
                  </v-btn>

                  <v-btn
                    v-show="$userPermission.hasPermission('ROLE_MODIFICAR_GR')"
                    id="btnsubmit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="view.elem.button.submit.title.current"
                    :loading="view.action.submit.busy"
                    :disabled="form.$state.isDisableButtonSubmit()"
                    @click="submit()">
                    <v-icon small>{{ view.elem.button.submit.class.current }}</v-icon>
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-flex>
          </v-expand-transition>
        </v-card>
      </v-flex>

      <v-flex md8>
        <data-table ref="paisTable" @editRow="load" @auditRow="audit" />
      </v-flex>
    </v-layout>
    <auditoria ref="auditModal" />
  </v-container>
</template>
<script>
import paisStates from "@/views/geograficos/pais/pais-state"; /** *******************************/
import paisAPI from "@/services/geograficos/pais"; /** *******************************/
import DataTable from "@/views/geograficos/pais/DataTable"; /** *******************************/
import Auditoria from "@/components/auditoria/Auditoria"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required } from "vuelidate/lib/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { submit } from "@/constants/buttons";
import tippy from "tippy.js";
import { Pais } from "@/models/geograficos/pais";

const action = { submit: { busy: false } };

export default {
  name: "PaisModule"
  , components: {
    DataTable
    , Auditoria
  }
  , data() {
    return {
      pais: new Pais()
      , form: new Object()
      , view: {
        title: this.$t("view.geograficos.pais.title")
        , action
        , elem: {
          button: { submit }
          , showForm: true
        }
      }
      , check: true
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    this.form = new paisStates(this);
    this.form.$setState("initial");
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.pais);
        handleResponse(respuesta, this.$t("view.geograficos.pais.errors"));
      } catch (error) {
        handleResponse(error, this.$t("view.geograficos.pais.errors"));
      }
    }
    , async load(clave) {
      try {
        const response = await paisAPI.get(clave);
        const { data: { results: { pais } } } = response;
        this.form.$setState("editing", pais);
      } catch (error) {
        console.log(error);
      }
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , async audit(clave = this.pais.clave, dataDescription = this.pais.nombre) {
      this.$refs.auditModal.loadAudit(clave, "TPais", dataDescription, this.view.title);
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        scrollToForm(this);
      }
    }
  }
  , validations: {
    pais: {
      nombre: { required }
      , lada: { required }
      , codigo: { required }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/geograficos/pais/Pais.vue